import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-review-survey-questions',
  templateUrl: './review-survey-questions.component.html',
  styleUrls: ['./review-survey-questions.component.css']
})
export class ReviewSurveyQuestionsComponent implements OnChanges, OnDestroy {
  @Input() surveyQuestions: any
  value: string = '';

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.surveyQuestions?.choices && this.surveyQuestions?.choices.length > 0) {
      this.value = this.getSelectedAnswer();
      this.cdRef.detectChanges();
    }
  }

  getSelectedAnswer() {
    const selectedDropDownIndex = this.surveyQuestions?.choices?.findIndex(items => items.value === this.surveyQuestions.value);
    return this.surveyQuestions?.choices[selectedDropDownIndex]?.text ? this.surveyQuestions?.choices[selectedDropDownIndex]?.text : '';
  }

  ngOnDestroy() {
    this.cdRef.detach();
  }
}
